<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useAppMode } from '@/composables/useAppMode'
import { useGameState } from '@/stores/gameState'

import EmptySeat from '@/components/table/seat/EmptySeat.vue'
import PlayerSeat from '@/components/table/seat/PlayerSeat.vue'

import type { Seat } from '@acepoker/contract/acepoker'
import type { SeatConfig } from '@/types'
import type { SeatClickEvent } from '@/components/table/types'

const props = withDefaults(
  defineProps<{
    index: number
    position: number
    seat: Seat | null
    config: SeatConfig
    settings?: {
      enableTimer?: boolean
    },
    disable?: boolean
  }>(),
  {
    settings: () => ({})
  }
)

const emit = defineEmits<{
  'seat-click': [SeatClickEvent]
}>()

const { mode: appMode } = useAppMode()
const { isOwner, isSpectator } = storeToRefs(useGameState())
</script>

<template>
  <component
    :is="seat ? PlayerSeat : EmptySeat"
    :key="seat?.playerId ?? `__empty-${position}`"
    :seat="seat"
    :mode="config.mode"
    class="table__seat"
    :class="{
      [`table__seat--${appMode}`]: true
    }"
    :popup-placement="config.popupPlacement"
    :index="index"
    :style="{
      left: `${config.left}%`,
      top: `${config.top}%`
    }"
    :disable="!seat && !isOwner"
    :sitdown="isSpectator"
    :enableTimer="settings.enableTimer"
    @seat-click="(data) => emit('seat-click', data)"
  >
    <template #popup="seatProps" v-if="$slots['seat-popup']">
      <slot name="seat-popup" v-bind="seatProps"></slot>
    </template>
  </component>
</template>

<style scoped></style>
